export default __webpack_public_path__ + "static/media/landing.3bbf9cad.jpg";